import { useEffect, useRef } from "react";

export const ParticleWave = ({ height = 280 }) => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let raf;
    let w, h, dpr;

    const resize = () => {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.offsetWidth;
      h = canvas.offsetHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);

    const GAP = 14;
    let t = 0;

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      const cols = Math.ceil(w / GAP) + 1;
      const rows = Math.ceil(h / GAP) + 1;
      for (let i = 0; i < cols; i++) {
        const x = i * GAP;
        const nx = x / w;
        for (let j = 0; j < rows; j++) {
          const yBase = j * GAP;
          const s1 = Math.sin(nx * 6 + t + j * 0.28);
          const s2 = Math.sin(nx * 11 - t * 0.7 + j * 0.15);
          const wave = s1 * 18 + s2 * 10;
          const y = yBase + wave;
          if (y < 0 || y > h) continue;
          const depth = y / h;
          const horiz = 0.3 + 0.7 * nx;
          const crest = Math.pow((s1 + 1) / 2, 3);
          const alpha = Math.min(0.95, depth * horiz * (0.25 + crest * 0.85));
          if (alpha < 0.03) continue;
          const r = 0.8 + depth * 1.3 + crest * 0.7;
          const g = 190 + Math.floor(crest * 50);
          const b = 220 + Math.floor(crest * 35);
          ctx.fillStyle = `rgba(60, ${g}, ${b}, ${alpha})`;
          ctx.beginPath();
          ctx.arc(x, y, r, 0, Math.PI * 2);
          ctx.fill();
        }
      }
      t += 0.012;
      raf = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <canvas
      ref={ref}
      className="absolute bottom-0 left-0 w-full pointer-events-none"
      style={{
        height,
        maskImage: "linear-gradient(to top, black 55%, transparent 100%)",
        WebkitMaskImage: "linear-gradient(to top, black 55%, transparent 100%)",
      }}
      data-testid="hero-particle-wave"
      aria-hidden="true"
    />
  );
};
